import { network } from 'services/network';

export const updateContract = (params) => {
    return network.post('api/bo/management/updateContract', params).then((response) => {
        return response.data;
    });
};
